import COUNTRIES from '../assets/countries.json';
import CURRENCIES from '../assets/currencies.json';
import LANGUAGES from '../assets/languages.json';

const Types = {};

Types.COUNTRIES = COUNTRIES;

Types.COUNTRIES_MAP = COUNTRIES.reduce(
  (agr, country) => { agr[country.iso3a2] = country; return agr; },
  {},
);

Types.POSTAL_CODE_REQUIRED_COUNTRIES = [
  // Europe
  'ad', 'al', 'am', 'at', 'az', 'ba', 'be', 'bg', 'by', 'ch', 'cy', 'cz',
  'de', 'dk', 'ee', 'es', 'fi', 'fr', 'gb', 'ge', 'gr', 'hr', 'hu', 'ie',
  'is', 'it', 'li', 'lt', 'lu', 'lv', 'mc', 'md', 'me', 'mk', 'mt', 'nl',
  'no', 'pl', 'pt', 'ro', 'rs', 'se', 'si', 'sk', 'sm', 'ua', 'va',
  // North America
  'ca', 'us',
];

Types.isPostalCodeRequiredCountry = (country) => (
  Types.POSTAL_CODE_REQUIRED_COUNTRIES.includes(`${country || ''}`.toLowerCase())
);

Types.COUNTRIES_BANNED = [
  'af', // Afghanistan
  'ir', // Iran
  'iq', // Iraq
  'il', // Israel
  'ly', // Lybia
  'ng', // Nigeria
  'pk', // Pakistan
  'qa', // Qatar
  'so', // Somalia
  'sd', // Sudan
  'ss', // South Sudan
  'sy', // Syria
  'ye', // Yemen
];

Types.CURRENCIES = CURRENCIES;
Types.CURRENCIES_MAP = CURRENCIES.reduce(
  (agr, currency) => { agr[currency.code] = currency; return agr; },
  {},
);

Types.LANGUAGES = LANGUAGES;
Types.LANGUAGES_MAP = LANGUAGES.reduce(
  (agr, language, i) => {
    language.index = i;
    agr[language.code] = language;
    return agr;
  },
  {},
);

export default Types;
